import React from 'react';
import PropTypes from 'prop-types';

import { generateXMHTUrl } from 'constants/urls';
import DocumentFrame from './DocumentFrame';

export default class DocumentXMHT extends DocumentFrame {
    static propTypes = {
        document: PropTypes.object.isRequired,
    };

    render() {
        const { document } = this.props;
        const url = generateXMHTUrl(document);

        return (
            <iframe
                title="xmht"
                className="iframe-document preview-paddings"
                ref={node => this.frame = node}
                onLoad={this.setHeight}
                src={url}
            />
        );
    }
}
